import { render, staticRenderFns } from "./AlbumCard.vue?vue&type=template&id=e9ee77d0&scoped=true&"
import script from "./AlbumCard.vue?vue&type=script&lang=js&"
export * from "./AlbumCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ee77d0",
  null
  
)

export default component.exports